__turbopack_context__.v({
  "gridContainer": "braiKa_gridContainer",
  "groupHeaderSkeleton": "braiKa_groupHeaderSkeleton",
  "searchInputSkeleton": "braiKa_searchInputSkeleton",
  "wl": "braiKa_wl",
});
